import { render, staticRenderFns } from "./BackofficeCotacaoOperadoraSuprimentos.vue?vue&type=template&id=7b2ca562&scoped=true"
import script from "./BackofficeCotacaoOperadoraSuprimentos.vue?vue&type=script&lang=ts"
export * from "./BackofficeCotacaoOperadoraSuprimentos.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeCotacaoOperadoraSuprimentos.vue?vue&type=style&index=0&id=7b2ca562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ca562",
  null
  
)

export default component.exports